var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconText = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h24v24H0z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#006C8E",
  d: "M1.5 23.5v-19q0-.824.587-1.413A1.93 1.93 0 0 1 3.5 2.5h17q.824 0 1.413.587.587.588.587 1.413v13q0 .824-.587 1.413a1.93 1.93 0 0 1-1.413.587h-15z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#D3F4FF",
  d: "M4.65 17.5H20.5v-13h-17v14.125z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#006C8E",
  d: "M5.5 15.5H14v-2H5.5zm0-3.5h13v-2h-13zm0-3.5h13v-2h-13z"
}))));
export default SvgIconText;